export const resolveApiErrorMessage = (error, fallbackMessage) => {
  if (!error) return fallbackMessage;

  const candidates = [error?.data, error?.response?.data];
  for (const candidate of candidates) {
    if (!candidate) continue;

    if (typeof candidate === "string" && candidate.trim()) return candidate.trim();

    if (typeof candidate === "object") {
      if (
        typeof candidate.message === "string" &&
        candidate.message.trim()
      ) {
        return candidate.message.trim();
      }
      if (typeof candidate.detail === "string" && candidate.detail.trim()) {
        return candidate.detail.trim();
      }

      const [firstKey] = Object.keys(candidate);
      const firstValue = candidate[firstKey];
      if (Array.isArray(firstValue) && firstValue[0]) return String(firstValue[0]);
      if (typeof firstValue === "string" && firstValue.trim()) {
        return firstValue.trim();
      }
    }
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message.trim();
  }

  return fallbackMessage;
};
